export const environment = {
  production: false,
  API_BASE_URL: 'https://dev-api.gaulbridge.com/api/v1/users/',
  GOOGLE_CLIENT_ID: '351155657621-u8b3qass9vnh0uvvuv65s4qgmop2qt1c.apps.googleusercontent.com',
  SOCKET_URL: 'https://dev-api.gaulbridge.com',
  EMAIL_LINK: 'support@gaulbridge.com',
  GET_HELP_LINK:'https://gaulbridge.com/contact-us',
  WHATSAPP_NUMBER: '+1 778 650 3613',
  TELEGRAM_LINK: 'https://t.me/gaulbridge',
  TERMS_LINK: 'https://www.gaulbridge.com/terms-and-conditions',
};
